// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Brunei from '../_raw/flag/icon_flag_brunei.png';

export default () => <img src={Brunei} alt="Brunei" />;
